
/** @format */

import React, { useEffect } from 'react';
import { useStyles } from './style';
import { PageContainer, LoadingPage, Empty } from 'components';
import { Grid } from '@mui/material';
import { Pagination } from '@mui/material';
import { animateScroll as scroll } from 'react-scroll';
import { GrantItem } from './components';
import Services from './services/WithdrawRuleServices';
import useCustomHook from './hooks';
import { getDynamicObjectAction , constBreadCrumbsTitle } from 'utility';

const TransferCredit = () => {
  // -- STATES --//
  const PAGE_SIZE = 12;

  const {
    isPageLoading,
    setIsPageLoading,
    totalCount,
    settotalCount,
    page,
    setPage,
    debits,
    setDebits,
    isWalletsLoading,
    setIsWalletsLoading,
    wallets,
    setWallets,
  } = useCustomHook();
  // -- HOOKS --//

  const classes = useStyles();

  useEffect(() => {
    getWallets();
    getGrantsList();
    return () => { };
  }, []);

  const actionsList =
  getDynamicObjectAction([
    'withdrawRuleAccountDigitalPage'

  ])

  // --API--//
  const getGrantsList = async (incomingPage = page) => {
    setIsPageLoading(true);
    try {
      const query = {
        offset: PAGE_SIZE * (incomingPage - 1),
        size: PAGE_SIZE,
      };
      const res = await Services.getWithdrawRules(query);
      setDebits(res?.result);
      settotalCount(res?.count ?? 0);
      setIsPageLoading(false);
    } catch (error) {
      setIsPageLoading(false);
    }
  };

  const getWallets = async () => {
    setIsWalletsLoading(true);
    try {
      const result = await Services.getCredit();
      setWallets(result?.result?.customerAmountSrvs ?? []);
    } catch (error) {
      console.log(`error`, error);
    }
    setIsWalletsLoading(false);
  };

  // -- OTHER FUNCTIONS --//

  const onChangePage = (_, pageNum) => {
    setPage(pageNum);
    scroll.scrollToTop();
    getGrantsList(pageNum);
  };
  const hintText = `در این بخش لیست مجوزهای برداشت از حساب دیجیتال که توسط شما به کسب‌وکارها داده شده‌است، نمایش داده می‌شود و شما می‌توانید مجوز اعطا‌شده را لغو نمایید`;

  return (
    <PageContainer
      title="مجوزهای برداشت از حساب دیجیتال من"
      className={classes.root}
      description={hintText}
      breadcrumbs={constBreadCrumbsTitle.WITHDRAW_RULE}
    >
      {actionsList['withdrawRuleAccountDigitalPage'] && (
        isPageLoading || isWalletsLoading ? (
          <LoadingPage />
        ) : (
          <>
            <Grid container spacing={2}>
              {debits?.length === 0 ? <Empty label="هیچ مجوز برداشتی یافت نشد!" /> : null}
              {debits.map((item, k) => (
                <Grid item xs={12} md={6} lg={4}>
                  <GrantItem
                    data={item}
                    wallets={wallets ?? []}
                    key={k}
                    refreshList={getGrantsList}
                  />
                </Grid>
              ))}
              {debits?.length > 0 ? (
                <Grid container justifyContent="center" className={classes.pagination}>
                  <Pagination
                    count={Math.ceil(totalCount / PAGE_SIZE)}
                    page={page}
                    onChange={onChangePage}
                    color="primary"
                  />
                </Grid>
              ) : null}
            </Grid>
          </>
        )
      )}
    </PageContainer>
  );
};

export default TransferCredit;
